import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { workbenchVerify } from '../lib/auth.js'
import ErrorAlert from '../components/ErrorAlert.jsx'
import { PAGE_FORM } from '../lib/layout.js'
import { BTN_PRIMARY_BLOCK, INPUT_BLOCK } from '../lib/ui.js'


export default function VerifyPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const returnTo = params.get('return') || '/admin'

  const [email, setEmail] = useState(params.get('email') || '')
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const submit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      await workbenchVerify({ email, code: code.trim().toUpperCase() })
      const qs = returnTo ? `?return=${encodeURIComponent(returnTo)}` : ''
      navigate(`/signin${qs}`, { replace: true })
    } catch (err) {
      setError(err.message || 'Verification failed.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className={`${PAGE_FORM} pb-12 pt-12`}>
      <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200/60 sm:p-8">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">Verify your email</h1>
        <p className="mt-2 text-sm text-slate-600">
          We sent a 6-character code to <span className="font-medium">{email || 'your inbox'}</span>.
          Enter it below to activate your account.
        </p>

        <form onSubmit={submit} className="mt-5 space-y-3" noValidate>
          <label className="block text-sm">
            <span className="block font-medium text-slate-700">Email</span>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={INPUT_BLOCK}
            />
          </label>

          <label className="block text-sm">
            <span className="block font-medium text-slate-700">Verification code</span>
            <input
              type="text"
              required
              inputMode="text"
              autoComplete="one-time-code"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="A1B2C3"
              className={`${INPUT_BLOCK} tracking-[0.4em] uppercase font-mono`}
            />
          </label>

          {error ? (
            <ErrorAlert title="Verification failed" message={error} source="VerifyPage" />
          ) : null}

          <button
            type="submit"
            disabled={loading || !email || code.trim().length < 6}
            className={BTN_PRIMARY_BLOCK}
          >
            {loading ? 'Verifying…' : 'Verify and continue'}
          </button>
        </form>

        <div className="mt-4 text-center text-sm text-slate-600">
          Wrong email?{' '}
          <Link to="/register" className="font-medium text-brand-700 hover:text-brand-800 hover:underline">
            Start over
          </Link>
        </div>

        <Link to="/" className="mt-6 block text-center text-sm text-slate-500 hover:text-slate-700">
          ← Back to calendar
        </Link>
      </div>
    </main>
  )
}
